// Catálogo de temas predefinidos y profesionales. Cada uno define los
// mismos valores que ya guardan "Color de Fondo" y "Colores del Sitio"
// — aplicar un tema es solo escribir esos valores de una sola vez.
// Los colores de texto NO se guardan aquí: se calculan al vuelo según
// el fondo real (ver utils/contraste.js), así siempre son legibles.

// Colores refrescados con tendencias de paletas profesionales 2026:
// neutros cálidos en vez de blanco frío, modo oscuro casi-negro (no negro
// puro), y variedad real entre fondos sólidos y degradados — no todos
// degradados hacia blanco.
const catalogoTemas = [
  {
    key: "institucional_azul",
    nombre: "Institucional Azul",
    descripcion: "El clásico del colegio — azul sólido, serio y confiable.",
    fondo_app: "#1e3a8a",
    fondo_difuminado: false,
    color_base: "#1e3a8a",
    header_difuminado: false,
  },
  {
    key: "claro_calido",
    nombre: "Claro Cálido",
    descripcion: "Fondo claro y cálido (no blanco frío), con encabezado en gris cálido oscuro.",
    fondo_app: "#f2ece2",
    fondo_difuminado: false,
    color_base: "#44403c",
    header_difuminado: false,
  },
  {
    key: "oscuro_elegante",
    nombre: "Oscuro Elegante",
    descripcion: "Modo oscuro casi-negro con matiz cálido, look premium tipo app moderna.",
    fondo_app: "#0a0a0c",
    fondo_difuminado: false,
    color_base: "#18181b",
    header_difuminado: false,
  },
  {
    key: "verde_escolar",
    nombre: "Verde Escolar",
    descripcion: "Verde bosque degradado hacia blanco, fresco y natural.",
    fondo_app: "#14532d",
    fondo_difuminado: true,
    color_base: "#14532d",
    header_difuminado: false,
  },
  {
    key: "calido_coral",
    nombre: "Cálido Coral",
    descripcion: "Naranja terracota degradado, cercano y amigable.",
    fondo_app: "#c2410c",
    fondo_difuminado: true,
    color_base: "#c2410c",
    header_difuminado: false,
  },
  {
    key: "violeta_real",
    nombre: "Violeta Real",
    descripcion: "Púrpura degradado, distintivo y elegante.",
    fondo_app: "#4c1d95",
    fondo_difuminado: true,
    color_base: "#4c1d95",
    header_difuminado: false,
  },
  {
    key: "aleman_elegante",
    nombre: "Alemán Elegante",
    descripcion:
      "Negro profundo con acento dorado — una interpretación elegante de los colores de Alemania, sin ser una bandera literal. Sólido, sin degradado.",
    fondo_app: "#141414",
    fondo_difuminado: false,
    color_base: "#c9a227",
    header_difuminado: false,
  },
];

// Pseudo-tema especial: "desactivar" vuelve a los colores neutros
// originales del sistema (los que traía antes de existir esta pantalla
// de Temas). No aparece en la galería — se usa para el botón "Desactivar".
export const TEMA_NINGUNO = {
  key: "ninguno",
  nombre: "Ninguno",
  fondo_app: "#ffffff",
  fondo_difuminado: false,
  color_base: "#1e40af",
  header_difuminado: false,
};

export default catalogoTemas;
